export default __webpack_public_path__ + "static/media/IC00030-attachment_org.37014817.svg";